import React, { useEffect, useState } from 'react'
import styles from "./pr.module.css"
import axios from 'axios'
import EditAdd from './EditAdd/EditAdd'
import TableCompo from '../../components/table/TableCompo'
const Pricerating = () => {
    const [data, setData] = useState({})
    const [message, setMessage] = useState()
    const [isLoading, setIsLoading] = useState(false);
    const [prevData, setPrevData] = useState([]);
    const [open, setOpen] = useState(false)
    const [selectedData, setSelectedData] = useState(null);

    const [page, setPage] = useState(() => ({
        pageno: 1,
        totalPage: 2
    }));
    const [permission, setPermission] = useState(false)

    const fetchData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/api/price/list`, { withCredentials: true });
            console.log("gotit", response?.data?.permission)
            if (response?.data?.pricelist) {
                const pricelist = response?.data?.pricelist
                setData(prev => ({ ...prev, [1]: pricelist }));
                setPrevData(pricelist);
                if (response?.data?.permission == 'read_write') {
                    setPermission(true)
                    console.log("gotit", permission)
                }
            }

        } catch (error) {
            console.log(error.response)
            // console.log(error)
            setMessage(error.response.data.message);

        }
    }
    useEffect(() => {
        fetchData();
    }, [])



    const handleSubmit = async (formData) => {
        const isUpdate = !!formData.pricing_id;
        try {
            if (!isUpdate) {
                const maxId = data[1]?.length > 0 ? Math.max(...data[1].map(item => item.pricing_id)) : 0;
                formData.pricing_id = maxId + 1;
            }

            const url = `${process.env.REACT_APP_URL}/api/price/${isUpdate ? 'update' : 'add'}`;
            const payload = [formData];

            const response = await axios.post(url, payload, { withCredentials: true });

            if (response.status === 200) {
                const updatedList = isUpdate
                    ? data[1].map(item => item.pricing_id === formData.pricing_id ? formData : item)
                    : [...data[1], formData];

                setData(prev => ({ ...prev, 1: updatedList }));
                setMessage({ type: 'success', message: response.data.message });
                return { success: true };
            }
        } catch (error) {
            console.error(error);
            // setMessage({ type: 'error', message: error.response.data.message });
            // return { success: false, message: error.response.data.message };
            throw error;
        }
    }

    return (
        <>
            <TableCompo
                title="Price rating"
                data={data}
                prevData={prevData}
                page={page}
                setPage={setPage}
                isLoading={isLoading}
                message={message}
                search={false}
                view={false}
                pagination={false}
                navPath={'details'}
                setOpen={setOpen}
                handleSubmit={handleSubmit}
                setSelectedData={setSelectedData}
                permission={permission}
            />
            <div className={`${styles.modalWrapper} ${open ? styles.open : ""}`}>
                <div className={styles.modal}>
                    <EditAdd
                        data={selectedData}
                        setOpen={setOpen}
                        handleSubmit={handleSubmit}
                    />
                </div>
            </div>
        </>
    )
}


export default Pricerating